import { PlaceRepository, Place, PlaceCode, PlaceName } from '@/Domain/Localization/Place'
import { ParishCode } from '@/Domain/Localization/Parish'

async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
interface StoredPlaces {
  [key: number]: Place[];
}
const storedPlaces: StoredPlaces = {
  1: [
    new Place(new PlaceCode(1), new PlaceName('Adro, O')),
    new Place(new PlaceCode(2), new PlaceName('Asadiño, O')),
    new Place(new PlaceCode(3), new PlaceName('Barreiros, Os')),
    new Place(new PlaceCode(4), new PlaceName('Beade')),
    new Place(new PlaceCode(5), new PlaceName('Borreiros de Abaixo')),
    new Place(new PlaceCode(6), new PlaceName('Cadaval, O')),
    new Place(new PlaceCode(7), new PlaceName('Calvelos')),
    new Place(new PlaceCode(8), new PlaceName('Cancelada')),
    new Place(new PlaceCode(9), new PlaceName('Chichorra, A'))
  ],
  2: [
    new Place(new PlaceCode(1), new PlaceName('Cruz, A')),
    new Place(new PlaceCode(2), new PlaceName('Fixós')),
    new Place(new PlaceCode(3), new PlaceName('Fonte, A')),
    new Place(new PlaceCode(4), new PlaceName('Loureiro, O')),
    new Place(new PlaceCode(5), new PlaceName('Merdil'))
  ]
}
export class InMemoryPlaceRepository implements PlaceRepository {
  async byParishId (parishCode: ParishCode): Promise<Place[]> {
    await wait(400)
    const code = parishCode.value()
    let foundPlaces: Place[] = []
    for (const key in storedPlaces) {
      if (key === code.toString()) {
        foundPlaces = storedPlaces[code]
      }
    }
    return foundPlaces
  }
}
